import React from "react";
import {Container, Grid, Paper, Typography, Card} from '@mui/material';
import TelegramIcon from '@mui/icons-material/Telegram';
import EmailIcon from '@mui/icons-material/Email';


const SupportCard = ({Icon, link, text}: {text?: string, Icon: any, link: string}) => {
    return (
        <Card
            component='a'
            target='_blank'
            href={link}
            elevation={3}
            sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textDecoration: 'none',
                p: 4,
            }}
        >
            <Icon fontSize='large'/>
            {text && (
                <Typography
                component={'span'}
                sx={{
                    fontWeight: 'bold',
                    fontSize: '1rem',
                    color: '#507ebc',
                    textAlign: 'center',
                    p: 2,
                }}
                >
                    {text
                }</Typography>
            )}
        </Card>
    )
}
const View = () => {
    return (
        <Paper>
            <Container sx={{p: 2, paddingBottom: 5}}>
                <Grid container>
                    <Grid sm={12} item>
                        <Typography
                            component={'h1'}
                            sx={{
                                fontWeight: 'bold',
                                fontSize: '1.5rem',
                                color: '#507ebc',
                                textAlign: 'center',
                                marginBottom: 5,
                            }}
                        >
                            Поддержка
                        </Typography>
                    </Grid>
                    <Grid
                        sm={6}
                        xs={12}
                        sx={{
                            display: 'flex',
                            px: {sm: 2},
                            pb: {xs: 2},
                            justifyContent: 'stretch',
                        }}
                    >
                        <SupportCard
                            Icon={TelegramIcon}
                            link='https://t.me/liftlearningsupport'
                        />
                    </Grid>
                    <Grid
                        sm={6}
                        xs={12}
                        sx={{
                            display: 'flex',
                            px: {sm: 2},
                            pb: {xs: 2},
                            justifyContent: 'stretch',
                        }}
                    >
                        <SupportCard
                            Icon={EmailIcon}
                            link='mailto:support@liftlearning.org'
                            text="Нужна поддержка?"
                        />
                    </Grid>
                </Grid>
            </Container>
        </Paper>
    )
}

export default View;